import React from 'react';
import { useAuth } from '../contexts/AuthContext';
import HeaderAuth from '../components/home/HeaderAuth';
import Header from '../components/home/Header';
import AboutScreen from '../components/home/AboutScreen';

const AboutPage = () => {
  const { user } = useAuth();

  return (
    <div>

      <AboutScreen />
    </div>
  );
};

export default AboutPage;